var lerp = require('./lerp');
var norm = require('./norm');
    /**
    * Maps a number from one scale to another.
    * @example map(3, 0, 4, -1, 1) -> 0.5
    */
    function map(val, min1, max1, min2, max2){
        return lerp( norm(val, min1, max1), min2, max2 );
    }
    module.exports = map;




//////////////////
// WEBPACK FOOTER
// ./~/mout/math/map.js
// module id = 1620
// module chunks = 0 1 2